import React, { useState } from "react";
import { Link } from "react-router-dom";
import SidebarLinks from "./SidebarLinks";

const OrdersSection = () => {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { tab: "all", descrption: "all" },
    { tab: "to Pay(1)", descrption: "to Pay(1)" },
    { tab: "to ship ", descrption: "to ship " },
    { tab: "to receive ", descrption: "to receive  " },
    { tab: "to review (50)", descrption: "to review (50)" },
  ];

  const [cartArray, setCartArray] = useState([
    {
      id: 1,
      productName: "Taylor Farms Broccoli Florets",
      productImg: "assets/images/thumbs/product-two-img1.png",
      productPrice: 5.99,
      quantity: 1,
      description:
        "Freshly picked broccoli florets, perfect for healthy meals.",
      isChecked: true,
    },
    {
      id: 2,
      productName: "Fresh Strawberries",
      productImg: "assets/images/thumbs/product-two-img2.png",
      productPrice: 130.49,
      quantity: 2,
      description:
        "Sweet and juicy strawberries, great for desserts or snacks.",
      isChecked: true,
    },
    {
      id: 3,
      productName: "Organic Avocado",
      productImg: "assets/images/thumbs/product-two-img3.png",
      productPrice: 2.99,
      quantity: 3,
      description: "Creamy organic avocados, rich in nutrients and flavor.",
      isChecked: false,
    },
    {
      id: 4,
      productName:
        "All-Natural Honeycomb Freshly Harvested from Local Bee Farms",
      productImg: "assets/images/thumbs/product-two-img1.png",
      productPrice: 19.99,
      quantity: 1,
      description:
        "Pure honeycomb straight from the hive, packed with natural sweetness and health benefits.",
      isChecked: true,
    },
    {
      id: 5,
      productName:
        "Certified Organic Free-Range Chicken Breast, Humanely Raised",
      productImg: "assets/images/thumbs/product-two-img2.png",
      productPrice: 15.49,
      quantity: 2,
      description:
        "Tender and juicy chicken breasts, raised without antibiotics or hormones, perfect for healthy meals.",
      isChecked: false,
    },
    {
      id: 6,
      productName:
        "Premium Wild-Caught Alaskan Salmon Filets, Sustainably Sourced",
      productImg: "assets/images/thumbs/product-two-img3.png",
      productPrice: 24.99,
      quantity: 3,
      description:
        "Fresh, wild-caught salmon fillets, packed with omega-3 fatty acids and perfect for grilling or baking.",
      isChecked: true,
    },
    {
      id: 7,
      productName:
        "Delicious Vegan Gluten-Free Chocolate Chip Cookies, Handcrafted with Organic Ingredients",
      productImg: "assets/images/thumbs/product-two-img1.png",
      productPrice: 8.99,
      quantity: 1,
      description:
        "Indulge in the rich flavor of vegan, gluten-free chocolate chip cookies made with organic ingredients.",
      isChecked: false,
    },
    {
      id: 8,
      productName:
        "Artisanal Aged Parmigiano Reggiano Cheese, 24-Month-Old, Imported from Italy",
      productImg: "assets/images/thumbs/product-two-img2.png",
      productPrice: 39.99,
      quantity: 1,
      description:
        "Handcrafted Parmigiano Reggiano cheese aged for 24 months, offering a rich, nutty flavor perfect for pasta or salads.",
      isChecked: true,
    },
    {
      id: 9,
      productName:
        "Exotic Blueberry and Raspberry Fusion Smoothie Mix with Organic Superfoods",
      productImg: "assets/images/thumbs/product-two-img3.png",
      productPrice: 12.49,
      quantity: 1,
      description:
        "A nutrient-packed smoothie mix combining organic blueberries, raspberries, and superfoods for a healthy boost.",
      isChecked: true,
    },
    {
      id: 10,
      productName:
        "Freshly Squeezed Cold-Pressed Organic Orange Juice, No Added Sugars or Preservatives",
      productImg: "assets/images/thumbs/product-two-img1.png",
      productPrice: 6.99,
      quantity: 2,
      description:
        "A refreshing, natural orange juice made from 100% organic oranges with no added sugars or preservatives.",
      isChecked: false,
    },
    {
      id: 11,
      productName:
        "Handmade Artisan Italian Focaccia Bread with Fresh Rosemary and Sea Salt",
      productImg: "assets/images/thumbs/product-two-img2.png",
      productPrice: 4.99,
      quantity: 1,
      description:
        "Deliciously soft, rosemary-infused focaccia bread, baked fresh and perfect as a side for any meal.",
      isChecked: true,
    },
    {
      id: 12,
      productName:
        "Superfood Acai Berry Powder Blend, Freeze-Dried for Maximum Nutrient Retention",
      productImg: "assets/images/thumbs/product-two-img3.png",
      productPrice: 22.49,
      quantity: 1,
      description:
        "Organic acai berry powder, freeze-dried to preserve nutrients, perfect for smoothies, bowls, and snacks.",
      isChecked: false,
    },
  ]);

  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleIsCheckedAll = () => {
    const newCheckedStatus = !isCheckedAll;
    setIsCheckedAll(newCheckedStatus);
    setCartArray((prev) =>
      prev.map((item) => ({
        ...item,
        isChecked: newCheckedStatus,
      }))
    );
  };

  const handleCheckboxChange = (id) => {
    setCartArray((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isChecked: !item.isChecked } : item
      )
    );

    const updatedCart = cartArray.map((item) =>
      item.id === id ? { ...item, isChecked: !item.isChecked } : item
    );
    setIsCheckedAll(updatedCart.every((item) => item.isChecked));
  };

  const totalPrice = cartArray.reduce(
    (acc, item) =>
      item.isChecked ? acc + item.productPrice * item.quantity : acc,
    0
  );

  return (
    <section className="payment py-40 bg-light-100">
      <div className="container container-lg px-lg-5">
        <div className="row flex-row-reverse gy-4">
          <div className="col-xl-9 col-lg-8 pb-10 px-24 ">
            <h4 className="fw-medium">lazmy Wallet</h4>
            <div
              className="d-flex justify-content-sm-between justify-content-lg-start gap-10 mt-24 align-items-lg-start "
              style={{ borderBottom: "1px solid gray" }}
            >
              {tabs.map((item, index) => (
                <div
                  key={index}
                  className={`" text-black payment-upper flex-center flex-column cursor-pointer fw-bold text-capitalize ${
                    activeTab === index ? "text-black " : "text-muted "
                  }`}
                  style={{
                    borderBottom: activeTab === index ? "3px solid black" : "",
                  }}
                  onClick={() => setActiveTab(index)}
                >
                  <i
                    className={`${item.icon} text-4xl`}
                    style={{ color: item.iconColor }}
                  ></i>
                  <p className="text-nowrap text-sm">{item.tab}</p>
                </div>
              ))}
            </div>
            <div className="bg-white p-10 my-20 flex-align">
              <p>Show :</p>
              <div className="mx-12     " style={{ minWidth: "10rem" }}>
                <select
                  name="type"
                  className="text-sm fw-light form-select rounded-0"
                  required
                >
                  <option value="Home">All Orders</option>
                  <option value="Office">New Orders</option>
                </select>
              </div>
            </div>
            <div className="row justify-content-center mx-0">
              {tabs.map((item, index) => (
                <div
                  key={index}
                  className={`col-xl-9 col-lg-8 h-100 bg-light py-12 w-100 text-capitalize ${
                    activeTab === index ? "d-block" : "d-none"
                  }`}
                  style={{
                    transform: activeTab === index ? "scale(1)" : "scale(0.95)",
                  }}
                >
                  <p className="mb-3 ">{item.descrption} </p>
                </div>
              ))}
            </div>
            {/* table */}

            <div className="cart-table">
              {cartArray.length === 0 ? (
                <div className="empty-cart text-center">
                  <h4>Your cart is empty!</h4>
                </div>
              ) : (
                <div className="overflow-x-auto scroll-sm-horizontal">
                  <table className="table bg-color-three border-top-0 border-right-0 border-left-0">
                    <tbody>
                      {cartArray.map((item) => (
                        <tr key={item.id}>
                          <td className="align-middle text-center">
                            <div className="table-product d-flex align-items-center gap-24">
                              <Link
                                to="/product-details"
                                className="table-product__thumb rounded-8 flex-center"
                              >
                                {/* Smaller image with adjusted size */}
                                <img
                                  src={item.productImg}
                                  alt={item.productName}
                                />
                              </Link>
                            </div>
                          </td>
                          <td className="align-middle text-center">
                            <div className="table-product__content text-start">
                              <h6
                                className="title text-lg fw-semibold mb-8"
                                style={{ minWidth: "3rem" }}
                              >
                                <Link
                                  to="/product-details"
                                  className="link text-line-2"
                                  tabIndex={0}
                                >
                                  {item.productName}
                                </Link>
                              </h6>
                              <h6 className="title text-sm fw-semibold mb-8 text-muted d-none d-md-block">
                                <Link
                                  to="/product-details"
                                  className="link text-line-2"
                                  tabIndex={0}
                                >
                                  {item.description}
                                </Link>
                              </h6>
                            </div>
                          </td>
                          <td
                            className="align-middle"
                            style={{
                              minWidth: "5rem",
                            }}
                          >
                            <span className="text-lg  text-main h6 mb-0 ">
                              Rs. {item.productPrice.toFixed(2)}
                            </span>
                          </td>

                          <td className="align-middle text-center text-nowrap text-sm ">
                            Qty. 3
                          </td>
                          <td className="align-middle text-center">
                            <button className="px-6 rounded-10 bg-light text-nowrap text-sm">
                              Completed
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            {/* table end */}
          </div>
          <div className="col-xl-3 col-lg-4 h-100 position-sticky top-0">
            <SidebarLinks />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrdersSection;
